export default "__VITE_ASSET__BsVHdqHJ__"